import Swal2, { SweetAlertIcon } from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const sweetalert = withReactContent(Swal2);

export async function successAsync(message: string | HTMLElement | JQuery<HTMLElement> | undefined, title?: string): Promise<void> {
  await sweetalert.fire({
    toast: true,
    timer: 2000,
    title: title,
    html: message,
    icon: 'success',
    showCloseButton: true,
    timerProgressBar: false,
    showConfirmButton: false,
  });
}

export async function infoAsync(message: string | HTMLElement | JQuery<HTMLElement> | undefined, title?: string): Promise<void> {
  await sweetalert.fire({
    toast: true,
    timer: 2000,
    title: title,
    icon: 'info',
    html: message,
    showCloseButton: true,
    timerProgressBar: false,
    showConfirmButton: false,
  });
}

export async function warningAsync(message: string | HTMLElement | JQuery<HTMLElement> | undefined, title = 'Warning'): Promise<void> {
  await sweetalert.fire({
    toast: true,
    html: message,
    icon: 'warning',
    titleText: title,
    showCloseButton: true,
    timerProgressBar: false,
    showConfirmButton: false,
  });
}

// v2 is read only (BLOCKED_FOR_V3=yes) : a change is made in v3's admin, so the popup links there in place of the change

export const V3_ADMIN_URL = 'https://prd-admin.titansecure.co.za';

export async function movedToV3Async(): Promise<void> {
  await sweetalert.fire({
    icon: 'info',
    titleText: 'Titan Secure v2 is read only',
    html: `Changes are now made in Titan Secure v3:<br/><a href="${V3_ADMIN_URL}" target="_blank" rel="noopener noreferrer">${V3_ADMIN_URL}</a>`,
    showConfirmButton: true,
    confirmButtonText: 'OK',
  });
}

export async function errorAsync(message: string | HTMLElement | JQuery<HTMLElement> | undefined, ...optionalParams: any[]): Promise<void> {
  console.error(message, ...optionalParams);
  await sweetalert.fire({
    toast: true,
    titleText: 'Error',
    icon: 'error',
    html: message,
    showConfirmButton: true,
  });
}

export async function confirmAsync(
  message: string | HTMLElement | JQuery<HTMLElement> | undefined,
  {
    icon = undefined,
    title = 'Confirm',
    confirmButtonText = 'Yes',
    cancelButtonText = 'No',
  }: {
    icon?: SweetAlertIcon | undefined,
    title?: string | HTMLElement | JQuery<HTMLElement> | undefined;
    confirmButtonText?: string;
    cancelButtonText?: string;
  } = {}
): Promise<boolean> {
  const result = await sweetalert.fire({
    icon,
    title,
    html: message,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  });

  return result.isConfirmed;
}

export async function promptAsync(
  message: string | HTMLElement | JQuery<HTMLElement>,
  {
    icon = undefined,
    title = 'Prompt',
    inputPlaceholder = '',
    confirmButtonText = 'Submit',
    cancelButtonText = 'Cancel',
  }: {
    icon?: SweetAlertIcon | undefined,
    title?: string | HTMLElement | JQuery<HTMLElement> | undefined;
    inputPlaceholder?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
  } = {}
): Promise<string | null> {
  const result = await sweetalert.fire({
    icon,
    title,
    html: message,
    input: 'text',
    inputPlaceholder,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  });

  return result.isConfirmed ? result.value ?? '' : null;
}
